/**
 * Sidebar sections an organization may hide from its own nav.
 *
 * ⚠ HIDING IS NOT A PERMISSION. A hidden section's routes are still reachable
 * by URL and its endpoints still serve — this only removes the nav entry. If
 * an org must not *have* a capability, that is RBAC (`lib/rbac.ts`), not this.
 * Never cite this setting as an access control in a review or a customer
 * conversation.
 *
 * Why it exists: a storeless 3PL owner org (Thread Lab) runs a production
 * floor and buys nothing — Ordering and Stock & Ops are permanently empty
 * chrome for them, and their clients' work reaches them through the partner
 * portal instead. Hiding dead sections is decluttering, not restriction.
 *
 * Only LABELLED sections are hideable. The unlabelled top cluster ('daily' /
 * 'client-daily' / 'prod-daily') is the workspace's home and always renders,
 * and Settings lives in the footer — so no combination of these can hide the
 * control that turns them back on.
 *
 * Ids MUST match the `NavSection.id` values in
 * `apps/frontend/src/components/layout/AppSidebar.tsx`. There is no compiler
 * link between the two; a rename there needs a matching edit here.
 */
export const HIDEABLE_NAV_SECTIONS = [
    // Owner / standard inventory workspace
    'ordering',
    'stock-ops',
    'insights',
    // Client (3PL tenant) inventory workspace
    'client-catalog',
    'client-ordering',
];
/** Label i18n keys, mirroring the section labels in AppSidebar. */
export const HIDEABLE_NAV_SECTION_LABEL_KEYS = {
    ordering: 'groupLabel.ordering',
    'stock-ops': 'groupLabel.stockOps',
    insights: 'groupLabel.insights',
    'client-catalog': 'groupLabel.catalog',
    'client-ordering': 'groupLabel.ordering',
};
